import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './RadioButtonWithIcon.scss';
import RadioOption from 'common/RadioOption';
import Icon from '../SF/MaterialIcon';
import classnames from 'classnames';

const RadioButtonWithIcon = (props) => {
        return (
            <div className={classnames(css['group-container'], {[css['error']]: !!props.error})}>
                {props.options.map((option, i) => (
                    <RadioOption
                        error={!!props.error}
                        key={i}
                        id={`${props.name}-${i}`}
                        value={option.id}
                        ariaLabel={option.name}
                        radioName={props.name}
                        onChange={() => props.onChange(option.id)}
                        label={<><Icon icon={option.icon} className={css['custom-icon']}/><span className={css['label']}>{option.name}</span></>}
                        isChecked={parseInt(option.id) === parseInt(props.value)}
                        required={!!props.required}
                    />
                ))}
            </div>
        );
    }

RadioButtonWithIcon.propTypes = {
    value: SFEntityID,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
        id: SFEntityID.isRequired,
        name: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired
    }))
};

export default RadioButtonWithIcon;
